// extracted by mini-css-extract-plugin
export default {"base":"GoogleAuthButton_base__2odiu","icon":"GoogleAuthButton_icon__mHkuX"};